/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withRouter } from 'react-router-dom';

import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import ContractSelectionComponent from './ContractSelectionComponent';
import { loadLeasingContractList, emptyContractListInState, saveFilters } from '../../actionCreators';
import { getContractsForRestructuring, getFilters } from '../../selectors';

const ContractSelectionContainer = ({
  showContractSelection,
  onCloseModal,
  onSelectContract,
  actions,
  onSettingsChanged,
  loading,
  contractsForRestructuring,
  settings,
  stateFilters,
  contractSelected,
  totalCount
}) => {
  const [paginationObj, setPagination] = useState({ page: 1, pageSize: 5 });
  const [contractsOnPage, setContractsOnPage] = useState([]);

  const pagination = (leasingContractList, pageSize, page) => {
    let current = (page - 1) * pageSize;
    const contractsOnPage = leasingContractList.slice(current, current + pageSize);
    return contractsOnPage;
  };

  const getContractsOnPage = (items, paginationObj) => {
    const page = paginationObj.page;
    const pageSize = paginationObj.pageSize;
    setContractsOnPage(pagination(items, pageSize, page));
  };

  const onChangePage = page => {
    getContractsOnPage(contractsForRestructuring, { ...paginationObj, page });
    setPagination({ ...paginationObj, page });
  };

  const onChangeFilterValue = (prop1, value1) => {
    onSettingsChanged({
      ...settings,
      filters: { ...settings.filters, [prop1]: value1 ? value1.trim() : ' ' }
    });
  };

  const onTextFilterChanged = name => value => {
    onChangeFilterValue(name, value);
    setPagination({ ...paginationObj, page: 1 });
  };

  const loadLeasingContracts = filters => {
    setPagination({ ...paginationObj, page: 1 });
    if (filters && (filters.uniqueId || filters.partnerName)) {
      actions.loadLeasingContractList(filters, paginationObj.page, paginationObj.pageSize);
    }
  };

  const handleRefreshList = () => {
    if (settings.filters && (settings.filters.uniqueId || settings.filters.partnerName)) {
      actions.emptyContractListInState(settings.filters);
      actions.loadLeasingContractList(settings.filters, paginationObj.page, paginationObj.pageSize);
    }
  };

  const handleContractSelect = item => {
    onSelectContract(item);
    onSettingsChanged({ ...settings, checkPage: true });
    actions.saveFilters(settings.filters);
  };

  useEffect(() => {
    if (contractSelected) onSettingsChanged({ filters: stateFilters, checkPage: true });
  }, [contractSelected, onSettingsChanged, stateFilters]);

  useEffect(() => {
    setContractsOnPage(pagination(contractsForRestructuring, paginationObj.pageSize, paginationObj.page));
  }, [contractsForRestructuring, paginationObj.page, paginationObj.pageSize]);

  useEffect(() => {
    if (settings.checkPage && contractSelected) {
      let index = -1;
      for (let i = 0; i < contractsForRestructuring.length; i++)
        if (
          contractsForRestructuring[i].contractId === contractSelected.contractId &&
          contractsForRestructuring[i].contractSiteId === contractSelected.contractSiteId
        ) {
          index = i;
          break;
        }
      if (index > -1) setPagination({ ...paginationObj, page: Math.floor(index / paginationObj.pageSize) + 1 });
      onSettingsChanged({ ...settings, checkPage: false });
    }
  }, [contractSelected, contractsForRestructuring, onSettingsChanged, paginationObj, settings]);

  return (
    <ContractSelectionComponent
      showContractSelection={showContractSelection}
      onCloseContractSelectionModal={onCloseModal}
      loadLeasingContractList={() => loadLeasingContracts(settings.filters)}
      filters={settings.filters}
      onChangeFilterValue={onTextFilterChanged}
      leasingContractList={contractsOnPage}
      contractSelected={contractSelected}
      onChangePage={onChangePage}
      isLoading={loading}
      onSelectContract={handleContractSelect}
      onRefreshList={handleRefreshList}
      pagination={paginationObj}
      totalCount={totalCount}
    />
  );
};

ContractSelectionContainer.propTypes = {
  showContractSelection: PropTypes.bool,
  closeContractSelection: PropTypes.func,
  onSelectContract: PropTypes.func.isRequired,
  settings: PropTypes.object.isRequired,
  onSettingsChanged: PropTypes.func.isRequired,
  contractSelected: PropTypes.object
};

function mapStateToProps(state, ownProps) {
  const { settings } = ownProps;

  const filters = getFilters(state);
  const { loading, loaded, content: contractsForRestructuring, totalCount } = getContractsForRestructuring(settings.filters, state);

  return { contractsForRestructuring, loading, loaded, stateFilters: filters, totalCount };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ loadLeasingContractList, emptyContractListInState, saveFilters }, dispatch)
  };
}

const ContractSelectionContainerConnected = withRouter(
  compose(connect(mapStateToProps, mapDispatchToProps), withTranslation())(ContractSelectionContainer)
);

const ContractSelectionContainerWrapper = props => {
  const [settings, setSettings] = useState({ filters: { uniqueId: '', partnerName: '' }, checkPage: false });

  const handleSettingsChanged = useCallback(obj => {
    setSettings({ ...obj });
  }, []);

  return <ContractSelectionContainerConnected settings={settings} onSettingsChanged={handleSettingsChanged} {...props} />;
};

export default ContractSelectionContainerWrapper;
